import { Component, OnInit, SimpleChanges, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material';
import { LoaderService } from '../../services/loaderService.service';
import { UtilsService } from 'app/main/services/utils.service';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Location } from '@angular/common';

@Component({
  selector: 'app-variation-proposal',
  templateUrl: './variation-proposal.component.html',
  styleUrls: ['./variation-proposal.component.scss']
})
export class VariationProposalComponent implements OnInit {

  richiedente: any;
  ricevente: any;
  disponibilitaRicevente: any;
  disponibilitaRichiedente: any;
  isModal: boolean;
  form: FormGroup;
  showForm: boolean;
  inputData: any;

  title: string;
  subtitle: string;
  color: string;

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) data,
    public dialogRef: MatDialogRef<VariationProposalComponent>,
    private location: Location,
    private fb: FormBuilder
  ) {
    if (data) {
      this.inputData = data;
      this.richiedente = data.richiedente;
      this.ricevente = data.ricevente;
      this.title = data.title;
      if (!data.color) {
        this.color = '#3c4252';
      } else {
        this.color = data.color;
      }
      this.subtitle = data.subtitle;
      this.disponibilitaRicevente = data.disponibilitaRicevente;
      this.disponibilitaRichiedente = data.disponibilitaRichiedente.availabilities;
      this.isModal = true;
    } else {
      this.isModal = false;
    }

    this.buildForm();
  }

  buildForm() {
    this.form = this.fb.group({
      motivazione: new FormControl(null, null)
    });
    this.showForm = true;
  }

  // tslint:disable-next-line:use-life-cycle-interface
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['richiedente']) {
      if (changes['richiedente'].currentValue) {
        if (changes['richiedente'].currentValue !== changes['richiedente'].previousValue) {
          this.richiedente = changes['richiedente'].currentValue;
        }
      }
    }
    if (changes['ricevente']) {
      if (changes['ricevente'].currentValue) {
        if (changes['ricevente'].currentValue !== changes['ricevente'].previousValue) {
          this.ricevente = changes['ricevente'].currentValue;
        }
      }
    }
  }

  async ngOnInit() {
  }

  back() {
    if (this.isModal) {
      this.inputData.nokCallback();
    } else {
      this.goBack(); // viene sempre fruito in modale
    }
  }
  confirm(value) {
    if (this.isModal) {
      this.inputData.okCallback(value);
    } else {
      // API value
      // studentBestMatchRequestID
    }
  }

  goBack() {
    this.location.back(); // viene sempre fruito in modale
  }

}
